'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Typography } from '@/components/ui/typography/typography.component';

export function FooterReserved() {
  const year = new Date().getFullYear();
  const gitCommitSha = process.env.NEXT_PUBLIC_GIT_COMMIT_SHA;
  const versionCode = gitCommitSha || 'live';

  return (
    <div
      className="border-b border-gray-300 md:border-gray-200 pb-4 mb-4 lg:mb-8 text-center md:text-right"
      data-testid={DataTestIdEnum.FOOTER_RESERVED}
    >
      <div className="flex flex-col md:flex-row items-baseline justify-between">
        <div className="w-full flex flex-col items-start justify-start md:w-auto">
          <Typography className="text-gray-600 font-light text-start">
            © Medprev,
            {' '}
            {year}
            ,
            {' '}
            {versionCode}
          </Typography>
          <Typography className="text-gray-600 font-light text-start">
            Todos os direitos reservados
          </Typography>
        </div>
      </div>
    </div>
  );
}
